module.exports = __webpack_public_path__ + "img/Weapon_146.5c0059bb.png";